import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { httpOptions } from 'src/app/constants/service.constants';
import { map, shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CommonCriteriaService {


  constructor(private http: HttpClient) {
    
  }

  // Future post requests based on logeed in user type

  
}

